import { 
  BulkAssignColumnConfig, 
  CsvHeader, 
  TableColumn 
} from 'types'

// Template CSV configuration
export const templateColumns: CsvHeader[] = [
  { label: 'LicenseId', key: 'LicenseId' },
  { label: 'NSCustomerId', key: 'NSCustomerId' },
  { label: 'AdminEmails', key: 'AdminEmails' },
]

// Results table configuration - single source of truth
const resultsColumnsConfig: BulkAssignColumnConfig[] = [
  { label: 'License Id', key: 'LicenseId', sortable: true },
  { label: 'Site Id', key: 'siteId', sortable: true },
  { label: 'Site Name', key: 'siteName', sortable: true },
  { label: 'Product Description', key: 'productDescription', sortable: true },
  { label: 'Status', key: 'status', sortable: true },
  { label: 'Is Active', key: 'isActive', sortable: true },
  { label: 'Admin Email', key: 'adminEmail', sortable: true },
  { label: 'Start Date', key: 'startDate', sortable: true },
  { label: 'Expiration Date', key: 'expirationDate', sortable: true },
]

// Generate CSV headers from column config
export const resultsHeaders: CsvHeader[] = resultsColumnsConfig.map(col => ({
  label: col.label,
  key: col.key,
}))

// Generate table columns from column config
export const tableColumns: TableColumn[] = resultsColumnsConfig.map(col => ({
  title: col.label,
  fieldValue: col.key,
  sort: col.sortable ?? false,
}))

// For backwards compatibility, export as csvTemplateHeaders
export const csvTemplateHeaders = templateColumns

